<template>
  <div class="on-job-print-dialog">
    <el-dialog
      title
      top="50%"
      v-model="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="close" @click="close">
        <img src="../../../assets/imgs/product/icon-close.png" />
      </div>
      <div class="on-job-print-pages" v-if="onJobInfo.archives_onjob_id">
        <div class="on-job-print-page" ref="printpage">
          <div class="header" v-if="showHeader">
            <div class="company-cn-name">{{onJobInfo.personal_content.company_name}}</div>
            <div class="company-en-name">{{onJobInfo.personal_content.company_name_en}}</div>
          </div>
          <div v-else class="empty-header"></div>
          <div class="body">
            <div class="on-job-title">Certificate</div>
            <div class="content-item">Dear Sir or Madam:</div>
            <div class="content-item">
              This is to certify that {{onJobInfo.passport_content.sex === 0 ? 'Mr.' : 'Ms.'}}{{onJobInfo.passport_content.surname_pinyin}} {{onJobInfo.passport_content.name_pinyin}}，
              passport No,{{onJobInfo.passport_content.passport_num}}，
              works in our company as {{onJobInfo.personal_content.job_en}} since {{formatEnDate(onJobInfo.personal_content.hiredate, false)}}.
              {{onJobInfo.passport_content.sex === 0 ? 'His' : 'Her'}} monthly salary is RMB {{onJobInfo.personal_content.monthly_income / 100}}.
              {{onJobInfo.passport_content.sex === 0 ? 'He' : 'She'}} is going to visit {{onJobInfo.personal_content.country_en}} from {{formatEnDate(onJobInfo.personal_content.arrival_date)}} to {{formatEnDate(onJobInfo.personal_content.return_date)}} for {{onJobInfo.personal_content.purpose_en}} reason.</div>
            <div class="content-item">All the travelling expenses, including air tickets, transportation, accommodation and health insurance, will be covered by {{onJobInfo.passport_content.sex === 0 ? 'himself' : 'herself'}}.</div>
            <div class="content-item">We hereby guarantee that {{onJobInfo.passport_content.sex === 0 ? 'he' : 'she'}} will abide by all the laws and regulations during {{onJobInfo.passport_content.sex === 0 ? 'his' : 'her'}} staying abroad. We also guarantee that {{onJobInfo.passport_content.sex === 0 ? 'he' : 'she'}} will be back to China on schedule and will continue to work for our company.</div>
            <div class="content-item">I sincerely hope that you grant {{onJobInfo.passport_content.sex === 0 ? 'him' : 'her'}} the necessary visa at your convenience. If you have any questions, please do not hesitate to contact our company.</div>
            <div class="content-item">Yours sincerely</div>
            <div class="company-info">
              <div class="company-info-item">Company Name: {{onJobInfo.personal_content.company_name_en}}</div>
              <div class="company-info-item">Add: {{onJobInfo.company_content.detail_addr_en}}, {{onJobInfo.company_content.city_en}}{{notShowProvinceList.indexOf(onJobInfo.company_content.province_code) > -1 ? '' : `, ${onJobInfo.company_content.province_en}`}}</div>
              <div class="company-info-item">Tel: {{onJobInfo.company_content.company_tel}}</div>
              <div class="company-info-item">Name of the Contact: {{onJobInfo.company_content.leader_name}}</div>
              <div class="company-info-item">Position of the leader: {{onJobInfo.company_content.leader_job_en}}</div>
              <div class="company-info-item">Signature: <span class="tips no-print">该处需领导手写签字，打印时不会显示该提示文案</span></div>
              <div class="company-info-item">Company Stamp: </div>
              <div class="company-info-item"><span class="tips no-print">该处需公司盖章，打印时不会显示该提示文案</span></div>
            </div>
            <div class="closing-date">{{onJobInfo.company_content.closing_date | date('YYYY/MM/DD')}}</div>
          </div>
        </div>

        <div class="bottom-block"></div>

        <div class="on-job-bottom">
          <el-checkbox
            class="show-header"
            v-model="showHeader"
          >显示公司抬头</el-checkbox>
          <div class="button">
            <el-button class="s-btn btn-lg btn-blue is-plain" @click="sendMail()">发送邮箱</el-button>
            <el-button class="s-btn btn-lg btn-blue is-plain" @click="download()" :loading="downloadLoading">下载</el-button>
            <el-button class="s-btn btn-lg btn-blue" @click="print()">打印</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import Http from '../../../libs/http';
import User from '../../../libs/user.js';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    onJobId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: this.show,
      onJobInfo: {},
      showHeader: true,
      enMonthMap: {
        0: 'Jan',
        1: 'Feb',
        2: 'Mar',
        3: 'Apr',
        4: 'May',
        5: 'Jun',
        6: 'Jul',
        7: 'Aug',
        8: 'Sep',
        9: 'Oct',
        10: 'Nov',
        11: 'Dec',
      },
      downloadLoading: false,
      notShowProvinceList: [110000, 120000, 310000, 500000], // 不显示省的code list
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  created() {
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      this.onJobInfo = {};

      Http.post('/archives_onjob_query', {
        onjob_id_list: [this.onJobId],
      }).then((res) => {
        this.onJobInfo = res.data[0];
        this.showHeader = !!this.onJobInfo.is_show_header;
      });
    },
    close() {
      this.visible = false;
    },
    // 格式化英文日期
    formatEnDate(date, showDay = true) {
      const dateObj = new Date(date);
      let day = dateObj.getDate();
      const month = dateObj.getMonth();
      const year = dateObj.getFullYear();
      if (day < 10) {
        day = `0${day}`;
      }
      return `${showDay ? `${day} ` : ''}${this.enMonthMap[month]}.${year}`;
    },

    sendMail() {
      this.$emit('send-mail', this.onJobId, this.showHeader);
    },
    download() {
      this.downloadLoading = true;
      Http.post('/archives_onjob_get_word', {
        archives_onjob_id: this.onJobId,
        is_show_header: this.showHeader ? 1 : 0,
      }).then((res) => {
        this.downloadLoading = false;
        sensorsdata.track('On_the_job_download', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id,
          country: this.onJobInfo.personal_content ? this.onJobInfo.personal_content.country : '',
        });
        window.open(res.url);
      }).catch(() => {
        this.downloadLoading = false;
      });
    },
    // 打印
    print() {
      sensorsdata.track('On_the_job_printing', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
        country: this.onJobInfo.personal_content ? this.onJobInfo.personal_content.country : '',
      });
      Http.post('/archives_onjob_header_update', {
        archives_onjob_id: this.onJobId,
        is_show_header: this.showHeader ? 1 : 0,
      });
      this.$print(this.$refs.printpage);
    },
  },
};
</script>

<style lang="less" scoped>
.on-job-print-dialog{
  /deep/ .el-dialog__wrapper {
    background:rgba(0,0,0,0.1);
    .el-dialog {
      transform: translate(-50%, -50%);
      margin: 0;
      width: 1000px;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
  }
  .close {
    position: absolute;
    top: 0;
    right: -86px;
    cursor: pointer;
  }
  .on-job-print-pages {
    width: 1000px;
    border-radius:2px;
    overflow: hidden;
    max-height: 80vh;
    overflow-y: auto;
    // 定义滚动条宽高及背景
    &::-webkit-scrollbar {
      width: 8px;
      background-color: #ffffff;
    }

    /*定义滚动条轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 4px;
    }

    // 定义滚动条滑块
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0,0,0,0.2);
      border-radius: 4px;

      &:hover {
        background-color: rgba(0,0,0,0.3);
      }
    }
    .bottom-block{
      height: 88px;
    }
    .on-job-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      border-top: 1px solid #DEE2E6;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      .button{
        display: flex;
        align-items: center;
        .s-btn{
          min-width: 128px;
        }
        .s-btn+.s-btn{
          margin-left: 16px;
        }
      }
    }
  }
}
</style>

<style lang="less">
.on-job-print-page{
  width: 1000px;
  -webkit-print-color-adjust: exact;
  line-height: 1;
  padding: 0 32px;
  background: #fff;
  .header{
    padding: 48px 0 40px 0;
    border-bottom: 2px solid #2F333D;
    .company-cn-name{
      color: #2F333D;
      font-size: 32px;
      text-align: center;
      font-weight: 600;
      word-wrap: break-word;
    }
    .company-en-name{
      margin-top: 20px;
      color: #2F333D;
      font-size: 18px;
      text-align: center;
      word-wrap: break-word;
    }
  }
  .empty-header{
    height: 160px;
  }
  .body{
    padding: 40px 32px;
    .on-job-title{
      color: #2F333D;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
    }
    .content-item{
      margin-top: 24px;
      color: #2F333D;
      font-size: 16px;
      line-height: 24px;
    }
    .company-info{
      margin-top: 64px;
      .company-info-item{
        color: #2F333D;
        font-size: 16px;
        line-height: 40px;
        .tips{
          color: #91999F;
        }
      }
    }
    .closing-date{
      margin-top: 100px;
      font-size: 16px;
      color: #2F333D;
      text-align: right;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/on-job-print-dialog.vue